import Axios from 'axios';

class ProductInfoApi {

    constructor() {
        this.api = Axios.create({
            baseURL: '/api/ProductInfo',
            timeout: 10000
        });
    }

    async addToCart(plid, isConfig, quantity, isCheckout, sender) {
        try {
            const response = await this.api.get('/AddToCart', { params: { plid, isConfig, quantity, isCheckout, sender } });
            return response;
        } catch (error) {
            console.error('Error adding to cart:', error);
            throw error;
        }
    }


}

export default new ProductInfoApi();